import { render, staticRenderFns } from "./post_edit.vue?vue&type=template&id=8c542b74&scoped=true&"
import script from "./post_edit.vue?vue&type=script&lang=js&"
export * from "./post_edit.vue?vue&type=script&lang=js&"
import style0 from "./post_edit.vue?vue&type=style&index=0&id=8c542b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c542b74",
  null
  
)

export default component.exports